import useBigScreenWebPage from "../../../unreal/BigScreenWebPage";
import {BigScreenSplash} from "../../../unreal/pages/pageDescriptors";
import styled from "@emotion/styled/macro";
import {Link} from "react-router-dom";
import BigScreenWebPage from "../../../unreal/BigScreenWebPage";

// Center the contents
const SplashDiv = styled.div`
  justify-content: space-around;
  align-items:center;
  width:100%; 
  height:100%;
  display:flex;
`

const Splash: React.FC<{image:string, url:string}> = (props) => {


    return <>
        <Link to={props.url}><SplashDiv>
        <div>
            <img src={props.image}/>
        </div>
    </SplashDiv>
    </Link>
        </>
}
export default Splash;